import 'youbora-adapter-videojs';

import Player from 'video.js/dist/types/player';
import * as youbora from 'youboralib';

import { environment } from '@environment';

import { ExtendedAdapter } from './adapter';

let youboraPlugin: any;

export function initAnalyticsPlugin() {
  youboraPlugin = new youbora.Plugin({
    accountCode: environment.videoAnalytics.accountCode,
    'app.name': 'web:joymo-tv',
    'app.releaseVersion': '2.0',
  });
  if (environment.videoAnalytics.debug) {
    youbora.Log.logLevel = youbora.Log.Level.DEBUG;
  }
}

/**
 * More options are described here:
 * https://documentation.npaw.com/integration-docs/docs/setting-options-and-metadata#parameter-description
 */
export interface AnalyticsOptions {
  username?: string;
  'content.transactionCode'?: string;
  'content.title': string;
  'content.duration'?: number;
  'content.isLive': boolean;
  'content.type'?: string;
  'content.channel': string;
  'content.metadata': {
    [key: string]: string;
  };
  'content.streamingProtocol': 'HLS';
  'content.saga'?: string;
  'content.tvShow'?: string;
  'content.season'?: string;
  'content.episodeTitle'?: string;
  'content.id': string;
  /** If access is through a subscription */
  'content.cost'?: string;
  /** If access is through a ticket */
  'content.price'?: string;
  'ad.title'?: string;
  'ad.resource'?: string;
  'ad.url'?: string;
  'content.imdbId'?: string;
  userType?: string;
}

function shouldEnableAnalytics(options: AnalyticsOptions): boolean {
  // Add additional checks with user centric here
  if (environment.videoAnalytics.enabled === false) {
    return false;
  }
  return Array.isArray(environment.videoAnalytics.enabled)
    ? environment.videoAnalytics.enabled.includes(options.username)
    : true;
}

export function setupAnalyticsForPlayer(
  player: Player,
  options: AnalyticsOptions
) {
  if (!shouldEnableAnalytics(options)) {
    return;
  }
  if (!youboraPlugin) {
    console.warn('Youbora was not initialized correctly');
    return;
  }
  youboraPlugin.setOptions({
    ...environment.videoAnalytics.options,
    ...options,
  });
  youboraPlugin.setAdapter(new ExtendedAdapter(player));
}

export function updateOptions(options: Partial<AnalyticsOptions>) {
  youboraPlugin.setOptions(options);
}
